import { a as h } from "./chunk-BaseElement-CJM6sCUz.js";
import { t as d } from "./chunk-custom-element-CN0MC8o7.js";
import "./chunk-lit-element-D3OkYgeM.js";
import { r as n } from "./chunk-query-all-DqbE3rZE.js";
var u = Object.defineProperty, w = Object.getOwnPropertyDescriptor, l = (i, e, t, c) => {
  for (var s = c > 1 ? void 0 : c ? w(e, t) : e, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (c ? a(e, t, s) : a(s)) || s);
  return c && s && u(e, t, s), s;
};
let o = class extends h {
  constructor() {
    super(), this._handleCollectionSwitch = this._handleCollectionSwitch.bind(this);
  }
  connectedCallback() {
    super.connectedCallback(), this.switchers && this.switchers.forEach((i) => {
      i.addEventListener(
        "click",
        (e) => this._handleCollectionSwitch(e)
      );
    });
  }
  _handleCollectionSwitch(i) {
    const e = i.currentTarget, t = e.getAttribute("data-collection-handle");
    t && (document.startViewTransition ? document.startViewTransition(() => {
      this.switchActiveCollection(e, t);
    }) : this.switchActiveCollection(e, t));
  }
  switchActiveCollection(i, e) {
    this.switchers.forEach((t) => {
      t === i ? t.setAttribute("data-active", "true") : t.removeAttribute("data-active");
    }), this.carousels.forEach((t) => {
      var c;
      t.getAttribute("data-target-handle") === e ? (t.classList.add("inline"), t.classList.remove("hidden"), (c = t.querySelector("simple-slider")) == null || c.checkScroll()) : (t.classList.add("hidden"), t.classList.remove("inline"));
    });
  }
};
l([
  n("[data-collection-handle]")
], o.prototype, "switchers", 2);
l([
  n("[data-target-handle]")
], o.prototype, "carousels", 2);
o = l([
  d("collection-switcher")
], o);
export {
  o as CollectionSwitcher
};
